import { IconTypes } from '@eika/icon';
import { Link } from '@eika/link';
import { useTranslation } from '@translations';
import './home-button.scss';
import { useLinks } from '@hooks/use-links';
import { useLocation } from 'react-router-dom';
import { useHomeButtonVisibility } from './use-home-button-visibility';

export const HomeButton = () => {
    const { overview, onlineBank } = useLinks();
    const shouldShowHomeButton = useHomeButtonVisibility();
    const { homeButton } = useTranslation();
    const location = useLocation();
    const isOnOverviewPage = location.pathname === overview.url || location.pathname === '/';

    const getLinkHref = () => (isOnOverviewPage ? onlineBank.url : overview.url);

    const getLinkText = () => (isOnOverviewPage ? homeButton.goToBank : homeButton.goToSaving);

    if (!shouldShowHomeButton) {
        return null;
    }

    return (
        <div className="home-button-wrapper">
            <Link
                className="home-button"
                linkType="return"
                icon={IconTypes.PIL_VENSTRE}
                href={getLinkHref()}
                aria-label={homeButton.ariaLabel}
            >
                {getLinkText()}
            </Link>
        </div>
    );
};
